/// <amd-module name="Artifacts/Root/types/IRoutedTabContainerProps" />

export interface IRoutedTabContainerProps {
  route: string;
}
